import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'fms-card-body',
	templateUrl: 'card-body.component.html',
	styleUrls: ['card-body.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [],
})
export class CardBodyComponent {}
